export default __webpack_public_path__ + "static/m-banh1-51275d8307d48e49c8ee6ee2db8a6c79.jpg";